<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getReps"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          class="ml-2"
          :to="{ name: 'reps-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-lg-1"></div>
        <div class="col-lg-4">Rep</div>
        <div class="col-lg-5">Branches</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-4 col-lg-1 my-auto">
          <v-lazy-image
            v-if="slotProps.item.image"
            :src="slotProps.item.image"
            class="img-fluid maxHeight50"
          />
        </div>

        <div class="col-8 col-lg-4 my-auto">
          <h5 class="m-0">{{ slotProps.item.name }}</h5>
        </div>

        <div class="col-lg-5 mt-2 my-lg-auto">
          <p class="m-0" v-for="rep in slotProps.item.reps" :key="rep.id">- {{ rep.branch.name }}</p>
        </div>

        <div class="col-lg-2 my-auto text-left text-lg-right pt-3 pt-md-0">

          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{
              name: 'reps-edit',
              params: { id: slotProps.item.id },
            }"
            class="text-primary table-action-icon"
          >
            <i class="lni lni-pencil"></i>
          </router-link>

          <span
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Delete"
            @click="confirmDelete(slotProps.item.id)"
            class="text-danger table-action-icon"
          >
            <i class="lni lni-trash"></i>
          </span>
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'reps' })"
      :lazy="true"
    >
      <router-view
        @repCreated="repCreated()"
        @repUpdated="repUpdated()"
      ></router-view>
    </b-modal>


  </div>
</template>

<script>
import repRepo from "@/api/repos/repRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getReps({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async deleteRep(id) {
      this.isBusy = true;
      try {
        await repRepo.delete(id);
        this.items = this.items.filter((item) => item.id !== id);
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete the rep.",
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((confirm) => (confirm ? this.deleteRep(id) : false))
        .catch((error) => console.log(error));
    },
    async getReps(e) {
      this.isLoad = true;
      try {
        let { data } = await repRepo.reps(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.reps.data;
        this.totalRows = data.reps.total;
        this.page = data.reps.current_page;
        this.fromRow = data.reps.from;
        this.toRow = data.reps.to;
        this.lastPage = data.reps.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    repCreated() {
      this.$bvToast.toast("Rep Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getReps({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    repUpdated() {
      this.$bvToast.toast("Rep Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getReps({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
